import { useAuthenticationStore } from '@/application/whitelabel/authentication/store';
import { Permission } from '@/types/global';

export function authenticatedUserHasPermission(permission: Permission): boolean {
  return useAuthenticationStore().user?.permissions.includes(permission) ?? false;
}
